import React from 'react'
import {
    Box,
    Grid,
    Skeleton as ChakraSkeleton
} from '@salesforce/retail-react-app/app/components/shared/ui'

const HomePage = () => {
    return (
        <Box data-testid="home-page-skeleton" layerStyle="page">
            {/* Banner Skeleton */}
            <Box
                width="100%"
                height={{base: '150px', md: '250px', lg: '300px'}}
                position="relative"
                marginBottom="30px"
            >
                <ChakraSkeleton
                    width="100%"
                    height="100%"
                    borderRadius="md"
                    startColor="gray.200"
                    endColor="gray.400"
                />
            </Box>

            {/* Grid Skeletons */}
            <Grid
                templateColumns={{base: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr'}} // Responsive columns
                gap="30px"
                width="100%"
            >
                <ChakraSkeleton
                    width="100%"
                    height="200px"
                    borderRadius="md"
                    startColor="gray.200"
                    endColor="gray.400"
                />
                <ChakraSkeleton
                    width="100%"
                    height="200px"
                    borderRadius="md"
                    startColor="gray.200"
                    endColor="gray.400"
                />
                <ChakraSkeleton
                    width="100%"
                    height="200px"
                    borderRadius="md"
                    startColor="gray.200"
                    endColor="gray.400"
                />
            </Grid>
        </Box>
    )
}

export default HomePage
